import { FormattedMessage } from 'react-intl';
import { useLocation, useNavigate } from 'react-router';

import SidebarTable from '@/components/SidebarTable';
import { CustomMileage } from '@/data/formatting/CustomMileage';
import { openInfoPage } from '@/features/app/header/info/Info';
import { InfoDialogContentType } from '@/features/app/header/info/InfoDialogDisplaySection';
import { ProActiveMaintenanceStatus } from '@/features/diagnostics/defaultTable/ProActiveMaintenanceStatus';
import { DiagnosticDetail } from '@/generated/fleetAggregationServiceTypes';
import { hasFeature } from '@/productsConfig';
import { NotSyncedInfoText } from './vehicleData/NotSyncedInfoText';

type DiagnosticsSidebarAssetInformationProps = {
    diagnosticsDetail: DiagnosticDetail;
};

export const DiagnosticsSidebarAssetInformation = ({ diagnosticsDetail }: DiagnosticsSidebarAssetInformationProps) => {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <SidebarTable
            entries={[
                {
                    label: <FormattedMessage id="intl-msg:fleetstatus.global.asset_vin" />,
                    text: diagnosticsDetail.asset?.vin,
                },
                {
                    label: <FormattedMessage id="intl-msg:fleetstatus.global.asset_mileage" />,
                    text: diagnosticsDetail.latest_events?.measured_at_distance ? (
                        <CustomMileage mileage={diagnosticsDetail.latest_events?.measured_at_distance} unit="kilometer" />
                    ) : (
                        <FormattedMessage id="intl-msg:fleetstatus.diagnostics.sidebar.mileage.no_data" />
                    ),
                },
                {
                    label: <FormattedMessage id="intl-msg:fleetstatus.diagnostics.sidebar.sync_status" />,
                    text: <NotSyncedInfoText measured_at_date={diagnosticsDetail.latest_events?.measured_at_date} />,
                },
                // the proactive maintenance status is rendered in the line with the components if ServiceCare S (MANSC-9130)
                ...(hasFeature('proActiveMaintenanceSettings', diagnosticsDetail.asset)
                    ? [
                          {
                              label: (
                                  <>
                                      <FormattedMessage id="intl-msg:fleetstatus.diagnostics.sidebar.proactive_maintenance_status" />
                                      <br />
                                      <span
                                          className="text-color-highlight cursor-pointer"
                                          onClick={() => openInfoPage(navigate, location.search, InfoDialogContentType.proactiveMaintenance)}
                                      >
                                          <span className="rioglyph rioglyph-question-sign margin-right-5" />
                                          <FormattedMessage id="intl-msg:fleetstatus.diagnostics.sidebar.proactive_maintenance_status.learn_about" />
                                      </span>
                                  </>
                              ),
                              text: <ProActiveMaintenanceStatus proActiveMaintenanceStatus={diagnosticsDetail.components.proactive_maintenance_status} withText={true} />,
                          },
                      ]
                    : []),
            ]}
        />
    );
};
